import { Component , OnInit} from '@angular/core';
import { LocationGuardService } from './core/services/location-guard.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit  {

  // ngOnInit() {
  //   // document.getElementsByTagName("html")[0].setAttribute("dir", "rtl");
  // }
  constructor(private locationGuard: LocationGuardService) {}

ngOnInit() {
   this.locationGuard.startMonitoringLocationPermission();
}
}
